import { useAccount } from "../Accounts.tsx";
import { useCallback, useState } from "react";
import { Alert, Box, Fab, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import MembersList from "./MembersList.tsx";
import InvitationsList from "./InvitationsList.tsx";
import { useInvitations } from "./Invitations.tsx";
import { useLoadingControl } from "../../../../../appfw/loading/use-loading-control.tsx";
import Tooltip from "@mui/material/Tooltip";
import { useBrandingTitleSuffix } from "../../../../../appfw/ui/branding/BrandingControl.tsx";
import { fabOverlayStyle } from "../../../EventerConsoleApp.styles.ts";
import { TextInputDialog } from "../../../../../appfw/ui/dialogs/TextInputDialog.tsx";
import { eventerConsoleApiClient } from "../../../../api-client/EventerConsoleApiClient.ts";
import { isValidEmail } from "../../../../../appfw/utils/EmailUtil.ts";

export default function MembersPage() {

    const account = useAccount()

    const invitationsController = useInvitations({
        account: account,
        loadingControl: useLoadingControl("invitations-" + account.podName),
    })
    const [inviteDialogOpen, setInviteDialogOpen] = useState(false)

    const handleInviteClick = useCallback(
        () => {
            setInviteDialogOpen(true)
        },
        [setInviteDialogOpen],
    )

    const onInviteDialogClose = useCallback(async (email: null | string) => {

        if (email != null) {
            await eventerConsoleApiClient.inviteMember({ accountId: account.id, email: email })
            await invitationsController.refresh()
        }

        setInviteDialogOpen(false)

    }, [invitationsController])

    const canManageMembers = account.role === "owner"

    useBrandingTitleSuffix("Nutzer")

    return (
        <>
            {!canManageMembers &&
                (
                    <Alert sx={{ marginTop: 2, marginLeft: 2, marginRight: 2 }} severity="info">Nur Lesezugriff</Alert>
                )
            }

            {canManageMembers && invitationsController?.invitations && invitationsController?.invitations?.length > 0 &&
                (
                    <Box sx={{ marginTop: 2, marginLeft: 2, marginRight: 2 }}>
                        <Typography variant="h6">Einladungen</Typography>
                        <InvitationsList invitationsController={invitationsController} />
                    </Box>
                )
            }

            <Box sx={{ marginTop: 2, marginLeft: 2, marginRight: 2, marginBottom: '32px' }}>
                <Typography variant="h6">Nutzer</Typography>
                <MembersList accountId={account.id} canManageMembers={canManageMembers} />
            </Box>

            {canManageMembers &&
                (<>
                    <Tooltip title={"Nutzer einladen"} describeChild>
                        <Fab
                            color="primary"
                            aria-label="Einladen"
                            sx={fabOverlayStyle}
                            onClick={handleInviteClick}
                            disabled={!canManageMembers}
                        >
                            <AddIcon />
                        </Fab>
                    </Tooltip>

                    <TextInputDialog
                        open={inviteDialogOpen}
                        onClose={onInviteDialogClose}
                        dialogTitle={"Nutzer einladen"}
                        dialogContent={"Gib die E-Mail-Adresse des Nutzers ein, den du einladen möchtest. Der Nutzer erhält dann eine E-Mail mit einem Link zur Registrierung."}
                        inputLabel={"E-Mail"}
                        cancelText={"Abbrechen"}
                        confirmText={"Einladen"}
                        validate={isValidEmail}
                    />
                </>)
            }
        </>
    )
}